<template>
    <!-- Update Confirmation Dialog -->
    <v-dialog v-model="confirmDialog" max-width="400px" persistent>
        <v-card>
            <v-card-title class="text-h5">
                <slot name="title">
                    Confirm {{ action == 'delete' ? 'delete' : 'update' }}
                </slot>
            </v-card-title>
            <v-card-text>
                <slot name="content">
                    Are you sure you want to {{ action == 'delete' ? 'delete' : 'update' }}
                    <span v-if="itemLabel"> - "{{ itemLabel }}"</span>?
                </slot>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="isProcessing" text color="blue darken-1" @click="cancel">Cancel</v-btn>
                <v-btn :disabled="isProcessing"  text color="primary" @click="confirm">
                    <span v-if="isProcessing">
                        <v-progress-circular
                            indeterminate
                            size="12"
                            width="2"
                            color="primary darken-3">
                        </v-progress-circular>
                        {{ action == 'delete' ? 'Deleting...' : 'Saving...' }}
                    </span>
                    <span v-else>{{ action == 'delete' ? 'Delete' : 'Save' }}</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { EventBus } from '@/js/event-bus.js'
import store from '@/js/store/index.js';
export default {

    props: {
        action: {
            type: String,
            default: 'update'
        },
        requestMethod: {
            type: String,
            default: 'put'
        },
        successMessage: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            isProcessing: false,
            confirmDialog: this.confirmDialogModel,
            itemLabel: '',
            endpoint: null,
            requestData: null,
        };
    },

    methods: {
        open(endpoint, data) {
            this.endpoint = endpoint;
            this.requestData = data;

            // limit itemLabel to 50 characters
            if (this.itemLabel.length > 50) {
                this.itemLabel = this.itemLabel.substring(0, 50) + '...';
            }
            this.confirmDialog = true;
            this.isProcessing = false;
        },
        cancel() {
            this.confirmDialog = false;
            this.$emit('on-cancel');
        },
        confirm() {
            this.isProcessing = true;
            this.$http
                .withClientId(store.getters['LRSettingsState/getShopifyUserId'])
                [this.requestMethod](this.endpoint, this.requestData)
                .then(({ data }) => {
                    if (this.successMessage != '') {
                        EventBus.$emit('show-success', this.successMessage);
                        return;
                    }
                    let responseMessage = this.itemLabel != '' ? `"${this.itemLabel}" ` : '';
                    responseMessage += this.action == 'delete' ? 'deleted successfully.' : 'updated successfully.';
                    EventBus.$emit('show-success', responseMessage);
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
                .finally(() => {
                    this.$emit('post-confirm');
                    this.confirmDialog = false;
                });

        }
    }
};
</script>
